export const TocSkeleton = () => (
  <div className={'hidden animate-pulse lg:block'}>
    <div className={'my-spacing-16 mr-spacing-96 h-spacing-12 rounded-full bg-gray-300'}></div>
    <div className={'my-spacing-16 mr-spacing-32 h-spacing-12 rounded-full bg-gray-300'}></div>
    <div className={'my-spacing-16 mr-spacing-80 h-spacing-12 rounded-full bg-gray-300'}></div>
    <div className={'my-spacing-16 mr-spacing-64 h-spacing-12 rounded-full bg-gray-300'}></div>
  </div>
)
